import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { ProfileImages, CommonImages } from "../../../../reusableUI/images";
import Modal from "./documentModal";
import { IoDocumentOutline, IoArrowBackCircleOutline } from "react-icons/io5";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { MdVerified, MdMenuBook, MdCancel } from "react-icons/md";
import { putDocumentVerification } from "../../../../Service/documentVerification";
import moment from "moment";
import ReusableTable from "../../../../reusableUI/table";
import Page from "../../../../reusableUI/page";
import {
  formatPhoneNumber,
  capitalizeFirstLetter,
  calculateAge,
} from "../../../../utils/Functions";
import DpModal from "./dpModal";
import { getUserProfile } from "../../../../Service/user";
import clsx from "clsx";
import { FiCopy } from "react-icons/fi";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { BsPeople } from "react-icons/bs";

import { InfoIcon } from "lucide-react";

const ProfileDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userId, page, currentPage } = location.state || {};
  const [user, setUser] = useState([]);
  const [paginationPage, setPaginationPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("Last 30 days");
  const [showModal, setShowModal] = useState(false);
  const [aadhar, setAadhar] = useState("");
  const [verificationData, setVerificationData] = useState([]);
  const [nursingCertificate, setNursingCertificate] = useState("");
  const [iAPCertificate, setIAPCertificate] = useState("");
  const [verificationType, setVerificationType] = useState("");
  const [course, setCourse] = useState("");
  const [statusCeritify, setCertificateStatus] = useState("");
  const [updated, setUpdated] = useState([]);
  const [copied, setCopied] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showAlreadyModal, setAlreadyModel] = useState(false);
  const [acceptNote, setAcceptNote] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [isImgModalOpen, setIsImgModalOpen] = useState(false);
  const [name, setName] = useState("");
  const [askBtn, setAskBtn] = useState(true);

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    if (user?.aadhaar?.key) {
      setAadhar(user?.aadhaar?.key);
    }
  }, [user]);

  const hasPartnerInfo =
    user?.partnerInfo && Object.keys(user?.partnerInfo || {}).length > 0;

  const getUser = async () => {
    try {
      const result = await getUserProfile(userId);

      if (result && result.data) {
        setUser(result.data);
      } else {
        console.log("Error fetching user profile: No data found.");
      }
    } catch (error) {
      console.log("Error fetching user profile:", error);
    }
  };

  const handleAddClick = (type, image, course, status) => {
    if (user?.aadhaar?.key) {
      setAadhar(user.aadhaar.key);
    }
    setNursingCertificate(image);
    setIAPCertificate(image);
    setVerificationType(type);
    setCourse(course);
    setShowModal(true);
    setCertificateStatus(status);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSave = (updatedUser) => {
    getUser(userId);
    setUpdated(updatedUser);

    if (user?.aadhaar && updatedUser?.personalInfo?.uploads?.aadhaar) {
      user.aadhaar.verfied = updatedUser.personalInfo.uploads.aadhaar.verified;
      user.aadhaar.actionBy = updatedUser.personalInfo.uploads.aadhaar.actionBy;
      user.aadhaar.reason = updatedUser.personalInfo.uploads.aadhaar.reason;
    }

    if (Array.isArray(user?.certificate) && updatedUser?.educationalInfo) {
      user.certificate.forEach((certificate, index) => {
        if (
          updatedUser.educationalInfo?.[index]?.certificate?.verified !==
          "Undefined"
        ) {
          certificate.certificate.verified =
            updatedUser.educitionalInfo[index].certificate.verified;

          if (updatedUser.educationalInfo?.[index]?.certificate?.actionBy) {
            certificate.certificate.actionBy =
              updatedUser.educationalInfo[index].certificate.actionBy;
          }

          if (updatedUser.educationalInfo?.[index]?.certificate?.reason) {
            certificate.certificate.reason =
              updatedUser.educationalInfo[index].certificate.reason;
          }
        }
      });
    }
  };

  const handleChange2 = (event, value) => {
    setPaginationPage(value - 1);
  };

  const openImgModal = () => setIsImgModalOpen(true);
  const closeImgModal = () => setIsImgModalOpen(false);

  if (!user) {
    return <div>Loading...</div>;
  }

  const handleBack = () => {
    if (page === "user") {
      localStorage.removeItem("profilePage");
      navigate(`../admin/user`, { state: { currentPage } });
    } else {
      localStorage.removeItem("profilePage");
      navigate("../admin/support");
    }
  };

  const handleLicenseVerification = (value) => {
    if (value === "accepted") {
      setShowAcceptModal(true);
    } else if (value === "rejected") {
      setShowDeclineModal(true);
    }
  };

  const handleAlreadyLicenseVerification = () => {
    setAlreadyModel(true);
  };

  const handleCopy = () => {
    const licenseNumber = user?.expirence?.licenseInfo?.nurse?.licenseNumber;
    if (licenseNumber) {
      navigator.clipboard.writeText(licenseNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleViewPartnerInfo = (id) => {
    localStorage.setItem("profilePage", "userProfile");
    navigate("/admin/hospitalProfile", {
      state: {
        userID: id,
      },
    });
  };

  const handleVerificationSubmit = async (
    status,
    verifierName,
    noteOrReason,
  ) => {
    const data = {
      docType:
        user?.role === "nurse" ? "nurseLicense" : "physiotherapistLicense",
      action: status,
      phone: user?.phone,
      course: course,
      actionBy: verifierName,
      reason: status !== "accepted" ? noteOrReason : "",
    };

    try {
      const response = await putDocumentVerification(data);

      if (response.error === false) {
        getUser(userId);
      } else {
        console.log("API Error:", response.error);
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setShowAcceptModal(false);
      setShowDeclineModal(false);
      setAlreadyModel(false);
      setAcceptNote("");
      setDeclineReason("");
      setName("");
    }
  };

  const licenseStatus = user?.licenseInfo?.status || "pending";

  const getStatusIcon = () => {
    if (licenseStatus === "accepted") {
      return (
        <MdVerified color="#00AA44" size={12} style={{ marginRight: 5 }} />
      );
    } else if (licenseStatus === "rejected") {
      return <MdCancel color="#FF0000" size={12} style={{ marginRight: 5 }} />;
    } else {
      return <></>;
    }
  };

  const getStatusText = () => {
    if (licenseStatus === "accepted") {
      return <p className="text-[#00AA44] text-[13px]">Verified</p>;
    } else if (licenseStatus === "rejected") {
      return <p className="text-[#FF0000] text-[13px]">Rejected</p>;
    } else {
      return <p className="text-[#FFB900] text-[13px]"></p>;
    }
  };

  const handleAskVerification = async (type) => {
    const isLicense = type === "license";

    const data = {
      docType: isLicense
        ? user?.role === "nurse"
          ? "nurseLicense"
          : "physiotherapistLicense"
        : "aadhaar",
      action: "rejected",
      phone: user?.phone,
      course: course,
      actionBy: "Admin",
      reason: isLicense
        ? "Please update your license information"
        : "Please update your Aadhaar information",
    };

    try {
      const response = await putDocumentVerification(data);
      if (!response.error) {
        getUser(userId);
      } else {
        console.log("API Error:", response.error);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  const isPhysio = user?.role === "physiotherapist";
  const licenseInfo = user?.expirence?.licenseInfo;
  const status = user?.expirence?.licenseInfo?.status || "pending";
  const iapUrl =
    user?.licenseInfo?.IAPCertificate ||
    user?.expirence?.licenseInfo?.physiotherapist?.IAPCertificate ||
    "";

  const showIAPSection = isPhysio && !!iapUrl;
  console.log("user", user);
  // Partner Info Section
  const renderPartnerInfoSection = () => {
    if (!hasPartnerInfo) return null;

    const partnerInfo = user.partnerInfo;
    const basicInfo = partnerInfo?.basicInfo || {};
    const addressInfo = partnerInfo?.addressInfo || {};
    const contactInfo = partnerInfo?.contactInfo || [];
    const id = user?.partnerInfo?._id;

    return (
      <>
        <div className="border-t border-gray-200 mt-[10px]"></div>
        <div className="flex flex-col p-4">
          <div className="flex flex-row items-center gap-2 px-4 mt-4 mb-4">
            <HiOutlineOfficeBuilding className="text-[#4951EC]" size={18} />
            <p className="text-[#4951EC] ml-2 text-[16px] ">
              Partner Information
            </p>
            <div
              className="mt-1 cursor-pointer"
              onClick={() => handleViewPartnerInfo(id)}
            >
              <InfoIcon size={15} color={"blue"} />
            </div>
          </div>

          <div className="flex flex-col min-[1100px]:flex-row justify-between px-6">
            {/* Basic Info */}
            <div className="flex-1">
              <p className="text-[#4951EC] text-[14px] mb-3 ">Basic Info</p>
              <div className="flex flex-row">
                <div className="mr-8">
                  <p className="text-[#8E8E8E] text-[14px] mb-3">
                    Company Name
                  </p>
                  {/* <p className="text-[#8E8E8E] text-[14px] mb-3">Slogan</p>
                  <p className="text-[#8E8E8E] text-[14px] mb-3">
                    Date of Registration
                  </p> */}
                  <p className="text-[#8E8E8E] text-[14px] mb-3">
                    Contact Person
                  </p>
                  <p className="text-[#8E8E8E] text-[14px] mb-3">
                    Contact Number
                  </p>
                  <p className="text-[#8E8E8E] text-[14px] mb-3">
                    Service Radius
                  </p>
                </div>
                <div className="ml-4">
                  <p className="text-[14px] font-normal mb-3">
                    {basicInfo?.name || "N/A"}
                  </p>
                  <p className="text-[14px] font-normal mb-3">
                    {contactInfo?.[0]?.name || "N/A"}
                  </p>
                  <p className="text-[14px] font-normal mb-3">
                    {contactInfo?.[0]?.phone || "N/A"}
                  </p>
                  {/* <p className="text-[14px] font-normal mb-3">
                    {basicInfo?.dob
                      ? moment(basicInfo.dob).format("DD-MM-YYYY")
                      : "N/A"}
                  </p> */}
                  {/* <p className="text-[14px] font-normal mb-3">
                    {basicInfo?.bedCount ?? "N/A"}
                  </p> */}
                  <p className="text-[14px] font-normal mb-3">
                    {addressInfo?.serviceRadius
                      ? `${addressInfo.serviceRadius} km`
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>

            {/* Address Info */}
            <div className="flex-1 ml-12">
              <p className="text-[#4951EC] text-[14px] mb-3 ">Address Info</p>
              <div className="flex flex-row">
                <div className="mr-8">
                  <p className="text-[#8E8E8E] text-[14px] mb-3">
                    Address Line 1
                  </p>
                  <p className="text-[#8E8E8E] text-[14px] mb-3">
                    Address Line 2
                  </p>
                  <p className="text-[#8E8E8E] text-[14px] mb-3">City</p>
                  <p className="text-[#8E8E8E] text-[14px] mb-3">State</p>
                  <p className="text-[#8E8E8E] text-[14px] mb-3">Pincode</p>
                  {/* <p className="text-[#8E8E8E] text-[14px] mb-3">Country</p> */}
                </div>
                <div className="ml-4">
                  <p
                    className="text-[14px] font-normal mb-3 max-w-[250px] truncate"
                    title={addressInfo?.address1}
                  >
                    {addressInfo?.address1 || "N/A"}
                  </p>
                  <p className="text-[14px] font-normal mb-3">
                    {addressInfo?.address2 || "N/A"}
                  </p>
                  <p className="text-[14px] font-normal mb-3">
                    {addressInfo?.city || "N/A"}
                  </p>
                  <p className="text-[14px] font-normal mb-3">
                    {addressInfo?.state || "N/A"}
                  </p>
                  <p className="text-[14px] font-normal mb-3">
                    {addressInfo?.pincode || "N/A"}
                  </p>
                  {/* <p className="text-[14px] font-normal mb-3">
                    {addressInfo?.country || "N/A"}
                  </p> */}
                </div>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          {Array.isArray(contactInfo) && contactInfo.length > 0 && (
            <>
              <div className="border-t border-gray-200 mt-4 mb-4"></div>
              <div className="px-6">
                <div className="flex flex-row items-center mb-4">
                  <BsPeople className="text-[#4951EC]" size={16} />
                  <p className="text-[#4951EC] text-[14px] ml-2 font-medium">
                    Contact Persons
                  </p>
                </div>
                <div className="overflow-x-auto">
                  <table className="min-w-[60%] table-auto border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-gray-100 border-b">
                        <th className="py-2 px-4 text-left text-[#4951EC] text-[13px] font-medium">
                          #
                        </th>
                        <th className="py-2 px-4 text-left text-[#4951EC] text-[13px] font-medium">
                          Name
                        </th>
                        <th className="py-2 px-4 text-left text-[#4951EC] text-[13px] font-medium">
                          Phone
                        </th>
                        <th className="py-2 px-4 text-left text-[#4951EC] text-[13px] font-medium">
                          Email
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {contactInfo.map((contact, index) => (
                        <tr
                          key={contact._id || index}
                          className="border-b hover:bg-gray-50"
                        >
                          <td className="py-2 px-4 text-[13px]">{index + 1}</td>
                          <td className="py-2 px-4 text-[13px]">
                            {contact?.name || "N/A"}
                          </td>
                          <td className="py-2 px-4 text-[13px]">
                            {contact?.phone
                              ? formatPhoneNumber(contact.phone)
                              : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-[13px]">
                            {contact?.email || "N/A"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  // Personal info when partnerInfo exists
  const renderPersonalInfoForPartner = () => {
    return (
      <div className="flex flex-col min-[1100px]:flex-row justify-between m-2">
        <div>
          <div className="flex flex-row items-center px-6">
            <img
              src={ProfileImages.userIcon}
              className="size-3.5"
              alt="User Icon"
            />
            <p className="text-[#4951EC] ml-2.5 text-[17px]">
              Personal Information
            </p>
          </div>
          <div className="flex flex-row mt-[15px] pl-1">
            <div className="ml-11">
              <p className="text-[#8E8E8E] text-[14px] mb-4">Name</p>
              <p className="text-[#8E8E8E] text-[14px] mb-4">Role</p>
              {/* <p className="text-[#8E8E8E] text-[14px] mb-4">Sub Role</p> */}
              <p className="text-[#8E8E8E] text-[14px] mb-4">Mobile Number</p>
              {/* <p className="text-[#8E8E8E] text-[14px] mb-4">Status</p>
              <p className="text-[#8E8E8E] text-[14px] mb-4">Payment</p> */}
              {/* <p className="text-[#8E8E8E] text-[14px] mb-4">
                Registered On
              </p> */}
            </div>

            <div className="ml-[100px]">
              <p className="text-[14px] min-w-[80px] font-normal mb-4">
                {user.name !== "undefined undefined"
                  ? capitalizeFirstLetter(user.name)
                  : "N/A"}
              </p>
              <p className="text-[14px] font-normal mb-4">
                {capitalizeFirstLetter(user.role) || "N/A"}
              </p>
              {/* <p className="text-[14px] font-normal mb-4">
                {user.subRole
                  ? capitalizeFirstLetter(user.subRole.replace(/-/g, " "))
                  : "N/A"}
              </p> */}
              <p className="text-[14px] font-normal mb-4">
                {formatPhoneNumber(user?.phone) || "N/A"}
              </p>
              {/* <p className="text-[14px] font-normal mb-4">
                <span
                  className={`px-2 py-1 rounded text-[12px] ${user?.status === "Verified"
                    ? "bg-green-100 text-green-600"
                    : "bg-yellow-100 text-yellow-600"
                    }`}
                >
                  {user?.status || "N/A"}
                </span>
              </p> */}
              {/* <p className="text-[14px] font-normal mb-4">
                <span
                  className={`px-2 py-1 rounded text-[12px] ${user?.payment === "Paid"
                    ? "bg-green-100 text-green-600"
                    : "bg-red-100 text-red-600"
                    }`}
                >
                  {user?.payment || "N/A"}
                </span>
              </p>
              <p className="text-[14px] font-normal mb-4">
                {user?.registeredOn
                  ? moment(user.registeredOn).format("DD-MM-YYYY hh:mm A")
                  : "N/A"}
              </p> */}
            </div>
          </div>
        </div>

        <div className="flex flex-row item-center mr-12">
          <div className="mt-5">
            <p className="text-[#8E8E8E] text-[14px] mb-4">Gender</p>
            <p className="text-[#8E8E8E] text-[14px] mb-4">Date of Birth</p>
            <p className="text-[#8E8E8E] text-[14px] mb-4">Age</p>
            <p className="text-[#8E8E8E] text-[14px] mb-4">On Call Duty</p>
            <p className="text-[#8E8E8E] text-[14px] mb-4">On Duty Status</p>
          </div>
          <div className="mt-5 ml-10">
            <p className="text-[14px] font-normal mb-4">
              {capitalizeFirstLetter(user.gender) || "N/A"}
            </p>
            <p className="text-[14px] font-normal mb-4">
              {user.dob ? moment(user.dob).format("DD-MM-YYYY") : "N/A"}
            </p>
            <p className="text-[14px] font-normal mb-4">
              {calculateAge(user.dob) || "N/A"}
            </p>
            <p className="text-[14px] font-normal mb-4">
              <span
                className={`px-2 py-1 rounded text-[12px] ${
                  user?.onCallDuty
                    ? "bg-green-100 text-green-600"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {user?.onCallDuty ? "ON" : "OFF"}
              </span>
            </p>
            <p className="text-[14px] font-normal mb-4">
              <span
                className={`px-2 py-1 rounded text-[12px] ${
                  user?.onDuty === "Active"
                    ? "bg-green-100 text-green-600"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {user?.onDuty || "N/A"}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-[#F3F6F5] ">
      <div
        className="flex items-center ml-3 p-2 cursor-pointer"
        onClick={handleBack}
      >
        <IoArrowBackCircleOutline size={22} color={"blue"} />
        <div className="flex flex-row item-center">
          <p className="text-[#4951EC] ml-2 text-[16px]">Profile </p>
          <p className="text-[#4951EC] ml-4 text-[16px]">| </p>
          <p className="text-[#4951EC] ml-5 text-[16px] ">
            {user.name !== "undefined undefined"
              ? capitalizeFirstLetter(user.name)
              : ""}
          </p>
          {/* {hasPartnerInfo && user.role !== "patient" && (
            <span className="ml-3 px-2 py-0.5 bg-blue-100 text-blue-600 text-[12px] rounded-full">
              Partner
            </span>
          )} */}
        </div>
      </div>
      <div className="overflow-y-auto h-[100vh] w-[100%] pb-[100px] ">
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg mt-2 m-2  mb-20 pb-10">
          <div className="relative text-center w-full">
            <img
              src={ProfileImages.cover1}
              className="w-full h-20 object-cover"
              alt="cover"
            />
            <div className="absolute inset-x-0 top-12 flex justify-center">
              <img
                src={user.profilePicture || CommonImages.defaultDp}
                className="h-16 w-16 rounded-full object-cover cursor-pointer"
                alt="Profile"
                onClick={openImgModal}
              />
            </div>
          </div>
          <div className="mt-10 text-center flex justify-center items-center gap-2">
            <h4 className="text-[16px] font-semibold flex items-center gap-1">
              {user.name !== "undefined undefined"
                ? capitalizeFirstLetter(user.name)
                : ""}
              {user?.aadhaar?.verfied === "accepted" && (
                <MdVerified
                  className="text-[#00AA44]"
                  size={18}
                  title="Verified"
                />
              )}
            </h4>
          </div>

          {/* MAIN CONDITIONAL:
              If partnerInfo exists and role != patient -> only Personal + Partner sections */}
          {hasPartnerInfo && user.role !== "patient" ? (
            <>
              {renderPersonalInfoForPartner()}
              {renderPartnerInfoSection()}
            </>
          ) : (
            <>
              {/* Existing logic for patient and non-partner users */}

              {user.role === "patient" ? (
                // Patient Details
                <>
                  {user.name !== "undefined undefined" ? (
                    <div className="flex flex-col min-[1100px]:flex-row justify-between m-2">
                      <div>
                        <div className="flex flex-row items-center px-6">
                          <img
                            src={ProfileImages.userIcon}
                            className="size-3.5"
                            alt="User Icon"
                          />
                          <p className="text-[#4951EC] ml-2.5 text-[14px]">
                            Personal Information
                          </p>
                        </div>
                        <div className="flex flex-row mt-[15px] pl-1">
                          <div className="ml-11">
                            <p className="text-[#8E8E8E] text-[14px] mb-4">
                              Gender
                            </p>
                            <p className="text-[#8E8E8E] text-[14px] mb-4">
                              Role
                            </p>
                            <p className="text-[#8E8E8E] text-[14px] mb-4">
                              Age
                            </p>
                            <p className="text-[#8E8E8E] text-[14px] mb-4">
                              Date of birth
                            </p>
                            {/* {user?.address &&
                              Object.keys(user.address).length > 0 && (
                                <p className="text-[#8E8E8E] text-[14px] mb-4">
                                  Aadhaar
                                </p>
                              )} */}
                          </div>

                          <div className="ml-[100px]">
                            <p className="text-[14px] font-normal mb-4">
                              {capitalizeFirstLetter(user.gender) || "N/A"}
                            </p>
                            <p className="text-[14px] font-normal mb-4">
                              {capitalizeFirstLetter(user.role) || "N/A"}
                            </p>
                            <p className="text-[14px] font-normal mb-4">
                              {calculateAge(user.dob) || "N/A"}
                            </p>
                            <p className="text-[14px] font-normal mb-4">
                              {moment(user.dob).format("DD-MM-YYYY")}
                            </p>

                            {/* {user?.address &&
                              Object.keys(user.address).length > 0 && (
                                <p
                                  className={` mb-6 text-[14px] font-normal flex items-center gap-2 ${user?.aadhaar?.verfied === "accepted"
                                    ? "text-[#00AA44]"
                                    : user?.aadhaar?.verfied
                                      ? "text-[#FFB900]"
                                      : "text-gray-500"
                                    }`}
                                >
                                  {user?.aadhaar?.verfied === "accepted" ? (
                                    <>
                                      <MdVerified />
                                      Verified
                                    </>
                                  ) : user?.aadhaar?.verfied ? (
                                    <div className="flex flex-row items-center gap-2">
                                      <button
                                        className={`px-4 py-1.5 rounded-md text-[13px] font-medium border transition duration-200 ${user?.aadhaar?.verfied === "rejected"
                                          ? "text-gray-400 border-gray-300 bg-gray-100 cursor-not-allowed"
                                          : "text-[#055AED] border-[#055AED] hover:bg-[#f0f4ff]"
                                          }`}
                                        onClick={() =>
                                          handleAskVerification("aadhaar")
                                        }
                                        disabled={
                                          user?.aadhaar?.verfied === "rejected"
                                        }
                                      >
                                        Ask to re-verify
                                      </button>
                                      {user?.aadhaar?.verfied === "rejected" && (
                                        <p className="text-[red] text-[13px]">
                                          Request Already Sent / Rejected
                                        </p>
                                      )}
                                    </div>
                                  ) : (
                                    "N/A"
                                  )}
                                </p>
                              )} */}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row item-center">
                        <div className="mt-5  ml-90">
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Mobile Number
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-10">
                            Address
                          </p>
                        </div>
                        <div className="mt-5 ml-10 mr-10">
                          <p className="ml-12 mb-4 text-[14px]  font-normal">
                            {formatPhoneNumber(user?.phone) || "N/A"}
                          </p>
                          <p className="ml-12 text-[14px] font-normal break-words max-w-xs mb-4">
                            {user?.address?.address1 ||
                            user?.address?.address2 ||
                            user?.address?.city ||
                            user?.address?.district ||
                            user?.address?.state ||
                            user?.address?.landmark ||
                            user?.address?.pincode ? (
                              <>
                                {user?.address?.address1 || ""},{" "}
                                {user?.address?.address2 || ""},{" "}
                                {user?.address?.city || ""},{" "}
                                {user?.address?.district || ""},{" "}
                                {user?.address?.state || ""},{" "}
                                {user?.address?.landmark || ""},{" "}
                                {user?.address?.pincode || ""}
                              </>
                            ) : (
                              "N/A"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="p-10 text-[#8E8E8E] text-[14px] text-center">
                      No Patient Details Found
                    </p>
                  )}

                  {/* Contact Person Details */}
                  <div className="border-t border-gray-200 mt-[10px]">
                    <div className="flex flex-row items-center px-8 mt-4">
                      <img
                        src={ProfileImages.userIcon}
                        className="size-3.5"
                        alt="User Icon"
                      />
                      <p className="text-[#4951EC] ml-2.5 text-[14px]">
                        Contact Person Details
                      </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-[180px_1fr] md:grid-cols-[200px_1fr] lg:grid-cols-[220px_1fr] gap-x-4 gap-y-3 max-w-full sm:max-w-[90%] md:max-w-[80%] lg:max-w-[70%] xl:max-w-[60%] mx-auto sm:mx-0 sm:ml-8 md:ml-12 lg:ml-14 mt-6 px-4 sm:px-0">
                      <div className="space-y-3">
                        <p className="text-[#8E8E8E] text-[13px] sm:text-[14px] ">
                          Contact Person Name
                        </p>
                        <p className="text-[#8E8E8E] text-[13px] sm:text-[14px] ">
                          Contact Person's Gender
                        </p>
                        <p className="text-[#8E8E8E] text-[13px] sm:text-[14px] ">
                          Date of Birth
                        </p>
                        <p className="text-[#8E8E8E] text-[13px] sm:text-[14px] ">
                          Mobile Number
                        </p>
                      </div>

                      <div className="space-y-3">
                        <p className="text-[13px] sm:text-[14px] font-normal text-gray-800 break-words">
                          :{" "}
                          {user?.contactPerson?.basicInfo?.nameInfo?.fullName ||
                            "N/A"}
                        </p>
                        <p className="text-[13px] sm:text-[14px] font-normal text-gray-800">
                          :{" "}
                          {capitalizeFirstLetter(
                            user?.contactPerson?.basicInfo?.nameInfo?.title ===
                              "Mr"
                              ? "Male"
                              : user?.contactPerson?.basicInfo?.nameInfo
                                    ?.title === "Ms" ||
                                  user?.contactPerson?.basicInfo?.nameInfo
                                    ?.title === "Mrs"
                                ? "Female"
                                : "N/A",
                          )}
                        </p>
                        <p className="text-[13px] sm:text-[14px] font-normal text-gray-800">
                          :{" "}
                          {user?.contactPerson?.basicInfo?.otherInfo?.dob
                            ? moment(
                                user.contactPerson.basicInfo.otherInfo.dob,
                              ).format("DD-MM-YYYY")
                            : "N/A"}
                        </p>
                        <p className="text-[13px] sm:text-[14px] font-normal text-gray-800">
                          :{" "}
                          {user?.contactPerson?.basicInfo?.otherInfo?.phone
                            ? formatPhoneNumber(
                                user.contactPerson.basicInfo.otherInfo.phone,
                              )
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                // Non-patient without partnerInfo
                <div>
                  {/* Personal Info */}
                  <div className="flex flex-col min-[1100px]:flex-row justify-start m-2">
                    <div>
                      <div className="flex flex-row items-center px-6">
                        <img
                          src={ProfileImages.userIcon}
                          className="size-3.5"
                          alt="User Icon"
                        />
                        <p className="text-[#4951EC] ml-2.5 text-[17px]">
                          Personal Information
                        </p>
                      </div>
                      <div className="flex flex-row mt-[15px] pl-1">
                        <div className="ml-11">
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Gender
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Role
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">Age</p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Date of birth
                          </p>
                        </div>

                        <div className="ml-[100px]">
                          <p className="text-[14px] font-normal mb-4">
                            {capitalizeFirstLetter(user.gender) || "N/A"}
                          </p>
                          <p className="text-[14px] font-normal mb-4">
                            {capitalizeFirstLetter(user.role) || "N/A"}
                          </p>
                          <p className="text-[14px] font-normal mb-4">
                            {calculateAge(user.dob) || "N/A"}
                          </p>
                          <p className="text-[14px] font-normal mb-4">
                            {moment(user.dob).format("DD-MM-YYYY") || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-row item-center">
                      <div className="mt-5 ml-96">
                        <p className="text-[#8E8E8E] text-[14px]">Address</p>
                        <p className="text-[#8E8E8E] text-[14px] mt-4 mb-4">
                          Mobile Number
                        </p>
                        {user?.address &&
                          Object.keys(user.address).length > 0 && (
                            <p className="text-[#8E8E8E] text-[14px] mb-4">
                              Aadhaar
                            </p>
                          )}
                      </div>

                      <div className="mt-5">
                        <p className="ml-12 text-[14px] font-normal">
                          {user?.address && Object.keys(user.address).length > 0
                            ? `${user?.address?.city || "N/A"}, ${
                                user?.location || "N/A"
                              }`
                            : "N/A"}
                        </p>

                        <p className="ml-12 mt-4 text-[14px] font-normal mb-4">
                          {formatPhoneNumber(user?.phone) || "N/A"}
                        </p>

                        {user?.address &&
                          Object.keys(user.address).length > 0 && (
                            <p
                              className={`ml-12 mb-2 text-[14px] font-normal flex items-center gap-2 ${
                                user?.aadhaar?.verfied === "accepted"
                                  ? "text-[#00AA44]"
                                  : user?.aadhaar?.verfied
                                    ? "text-[#FFB900]"
                                    : "text-gray-500"
                              }`}
                            >
                              {user?.aadhaar?.verfied === "accepted" ? (
                                <>
                                  <MdVerified />
                                  Verified
                                </>
                              ) : user?.aadhaar?.verfied ? (
                                <div className="flex flex-row items-center gap-2">
                                  <button
                                    className={`px-4 py-1.5 rounded-md text-[13px] font-medium border transition duration-200 ${
                                      user?.aadhaar?.verfied === "rejected"
                                        ? "text-gray-400 border-gray-300 bg-gray-100 cursor-not-allowed"
                                        : "text-[#055AED] border-[#055AED] hover:bg-[#f0f4ff]"
                                    }`}
                                    onClick={() =>
                                      handleAskVerification("aadhaar")
                                    }
                                    disabled={
                                      user?.aadhaar?.verfied === "rejected"
                                    }
                                  >
                                    Ask to re-verify
                                  </button>

                                  {user?.aadhaar?.verfied === "rejected" && (
                                    <p className="text-[red] text-[13px]">
                                      Request Already Sent / Rejected
                                    </p>
                                  )}
                                </div>
                              ) : (
                                "N/A"
                              )}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>

                  {/* Emergency Contacts */}
                  <div className="border-t border-gray-200 mt-[10px]"></div>
                  <div className="flex flex-row items-center px-8 mt-5 mb-3">
                    <img
                      src={ProfileImages.contactIcon}
                      className="size-3.5"
                      alt="Contact Icon"
                    />
                    <p className="text-[#4951EC] ml-2.5 text-[16px]">
                      Emergency Contacts
                    </p>
                  </div>
                  <div className="flex flex-row mt-[15px] px-14">
                    <div>
                      <p className="text-[#8E8E8E] text-[14px] min-w-[80px] mb-3">
                        Emergency Contact 1
                      </p>
                      <p className="text-[#8E8E8E] text-[14px] min-w-[80px]">
                        Emergency Contact 2
                      </p>
                    </div>
                    <div className="ml-[35px]">
                      <p className="text-[14px] min-w-[80px] font-normal mb-3">
                        {user?.emergencyContacts?.[0]?.name || "N/A"}
                      </p>
                      <p className="text-[14px] min-w-[80px] font-normal">
                        {user?.emergencyContacts?.[1]?.name || "N/A"}
                      </p>
                    </div>
                    <div className="ml-[35px] mt-1">
                      <p className="text-[14px] min-w-[80px] font-normal mb-2">
                        {String(user?.emergencyContacts?.[0]?.phone) ===
                        "undefined"
                          ? "N/A"
                          : formatPhoneNumber(
                              user?.emergencyContacts?.[0]?.phone,
                            )}
                      </p>
                      <p className="text-[14px] min-w-[80px] font-normal">
                        {String(user?.emergencyContacts?.[1]?.phone) ===
                        "undefined"
                          ? "N/A"
                          : formatPhoneNumber(
                              user?.emergencyContacts?.[1]?.phone,
                            )}
                      </p>
                    </div>
                  </div>

                  {/* Educational Info */}
                  <div className="border-t border-gray-200 mt-[10px]"></div>
                  <div className="flex flex-col">
                    <div className="flex flex-row items-center px-8 mt-5 mb-3">
                      <MdMenuBook color="#4951EC" size={18} />
                      <p className="text-[#4951EC] ml-2.5 text-[16px]">
                        Educational Information
                      </p>
                    </div>

                    <div className="flex flex-row flex-wrap px-8">
                      {user?.certificate?.length > 0 ? (
                        user.certificate.map((cert, index) => (
                          <div
                            key={index}
                            className={`flex-1 min-w-0 min-[1100px]:min-w-[400px] p-4 ${
                              index > 0 ? "md:pl-8" : ""
                            }`}
                          >
                            <p className="text-gray-600 font-semibold mb-4 text-[15px]">
                              Certificate #{index + 1}
                            </p>
                            <div className="flex flex-row">
                              <div className="pr-4">
                                <p className="text-[#8E8E8E] text-[14px] mb-4">
                                  Course
                                </p>
                                <p className="text-[#8E8E8E] text-[14px] mb-4">
                                  Institute
                                </p>
                                <p className="text-[#8E8E8E] text-[14px] mb-4">
                                  Year
                                </p>
                              </div>

                              <div className="ml-10">
                                <p className="text-[14px] font-normal mb-4">
                                  {cert?.course || "N/A"}
                                </p>
                                <p className="text-[14px] font-normal mb-4">
                                  {cert?.institutionName || "N/A"}
                                </p>
                                <p className="text-[14px] font-normal mb-4">
                                  {cert?.startDate && cert?.endDate
                                    ? `${moment(cert.startDate).format(
                                        "YYYY",
                                      )} - ${moment(cert.endDate).format(
                                        "YYYY",
                                      )}`
                                    : "N/A"}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="w-full p-4">
                          <div className="flex flex-row">
                            <div className="pr-4">
                              <p className="text-[#8E8E8E] text-[14px] mb-4">
                                Course
                              </p>
                              <p className="text-[#8E8E8E] text-[14px] mb-4">
                                Institute
                              </p>
                              <p className="text-[#8E8E8E] text-[14px] mb-4">
                                Year
                              </p>
                            </div>
                            <div className="ml-10">
                              <p className="text-[14px] font-normal mb-4">
                                N/A
                              </p>
                              <p className="text-[14px] font-normal mb-4">
                                N/A
                              </p>
                              <p className="text-[14px] font-normal mb-4">
                                N/A
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Work Experience */}
                  <div className="border-t border-gray-200 mt-[10px]"></div>
                  <div className="flex flex-row">
                    <div>
                      <div className="flex flex-row items-center px-8 mt-5 mb-3">
                        <img
                          src={CommonImages.exp}
                          className="size-3.5"
                          alt="Contact Icon"
                        />
                        <p className="text-[#4951EC] ml-2.5 text-[16px]">
                          Work Experience
                        </p>
                      </div>
                      <div className="flex flex-row mt-[15px] px-14">
                        <div>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Years of Experience
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Most Recent Experience
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Reference to Contact
                          </p>
                        </div>
                        <div className="ml-[35px]">
                          <p className="text-[14px] font-normal mb-4">
                            {capitalizeFirstLetter(
                              user?.expirence?.yearsOfExperience,
                            ) || "N/A"}
                          </p>
                          <p className="text-[14px] font-normal mb-4">
                            {capitalizeFirstLetter(
                              user?.expirence?.recentExperience?.where,
                            ) || "N/A"}
                          </p>
                          <p className="text-[14px] font-normal">
                            {
                              user?.expirence?.recentExperience
                                ?.referenceContact?.nameInfo?.title
                            }{" "}
                            {user?.expirence?.recentExperience?.referenceContact
                              ?.nameInfo?.fullName || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-row mt-10 mr-12">
                      <div className="mt-5 ml-80">
                        <p className="text-[#8E8E8E] text-[14px] mb-4">
                          Hospital Name, location & pin
                        </p>
                        <p className="text-[#8E8E8E] text-[14px] mb-4">
                          Start & end date
                        </p>
                        <p className="text-[#8E8E8E] text-[14px]">
                          Reference Contact Number
                        </p>
                      </div>
                      <div className="mt-5">
                        <p className="ml-12 text-[14px] font-normal mb-4">
                          {user?.expirence?.recentExperience?.hospitalName ||
                            "N/A"}
                        </p>
                        <p className="ml-12 text-[14px] font-normal mb-4">
                          {(() => {
                            const { startDate, endDate } =
                              user?.expirence?.recentExperience || {};

                            if (
                              startDate &&
                              moment(startDate).isValid() &&
                              endDate &&
                              moment(endDate).isValid()
                            ) {
                              return `${moment(startDate).format(
                                "MMMM D, YYYY",
                              )} - ${moment(endDate).format("MMMM D, YYYY")}`;
                            }

                            if (
                              startDate &&
                              moment(startDate, "DD - MM - YYYY").isValid()
                            ) {
                              return `${moment(startDate).format(
                                "MMMM D, YYYY",
                              )} - Present`;
                            }

                            return "N/A";
                          })()}
                        </p>

                        <p className="ml-12 text-[14px] font-normal">
                          {formatPhoneNumber(
                            user?.expirence?.recentExperience?.referenceContact
                              ?.phone,
                          ) || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Spacing */}
              <div className="flex flex-row mt-[10px] px-14 mb-4">
                <div></div>
                <div className="ml-[60px]"></div>
              </div>

              <div className="border-t border-gray-200 mt-[10px]"></div>

              {user?.role !== "patient" && (
                <div className="flex flex-row items-center px-8 mt-5 mb-3">
                  <img
                    src={CommonImages.verification}
                    className="size-3.5"
                    alt="Contact Icon"
                  />
                  <p className="text-[#4951EC] ml-2.5 text-[16px]">
                    Verification
                  </p>
                </div>
              )}

              <div className="flex flex-row mt-[15px] px-14 mb-8 gap-60">
                {/* Certificates */}
                {user?.role !== "patient" && (
                  <div>
                    <p className="text-[#8E8E8E] text-[14px] min-w-[80px]">
                      Certificate
                    </p>

                    <div className="mt-2">
                      {user?.certificate?.length > 0 ? (
                        user.certificate.map((item, index) => {
                          const certificateStatus = String(
                            item?.certificate?.verified ?? "pending",
                          );

                          const statusText = () => {
                            if (certificateStatus === "accepted") {
                              return (
                                <p className="text-[#00AA44] text-[13px]">
                                  Verified
                                </p>
                              );
                            } else if (certificateStatus === "rejected") {
                              return (
                                <p className="text-[#FF0000] text-[13px]">
                                  Rejected
                                </p>
                              );
                            } else {
                              return (
                                <p className="text-[#FFB900] text-[13px]">
                                  Pending
                                </p>
                              );
                            }
                          };

                          const statusIcon = () => {
                            if (certificateStatus === "accepted") {
                              return (
                                <MdVerified
                                  color="#00AA44"
                                  size={12}
                                  style={{ marginRight: 5 }}
                                />
                              );
                            } else if (certificateStatus === "rejected") {
                              return (
                                <MdCancel
                                  color="#FF0000"
                                  size={12}
                                  style={{ marginRight: 5 }}
                                />
                              );
                            } else {
                              return (
                                <AiOutlineExclamationCircle
                                  color="#FFB900"
                                  size={12}
                                  style={{ marginRight: 5 }}
                                />
                              );
                            }
                          };

                          const isButtonDisabled =
                            certificateStatus === "rejected";

                          return (
                            <div key={index} className="mb-4 mt-2">
                              <div className="flex flex-row items-center gap-4 mb-2">
                                <div
                                  className={`bg-[#e6f2fa] rounded-[10px] p-2 flex items-center gap-1 mt-1 cursor-pointer ${
                                    isButtonDisabled ? "opacity-50" : ""
                                  }`}
                                  onClick={() =>
                                    item?.certificate?.key &&
                                    handleAddClick(
                                      "Nursing Certificate",
                                      item.certificate.key,
                                      item?.course,
                                      certificateStatus,
                                    )
                                  }
                                >
                                  <IoDocumentOutline
                                    color={
                                      isButtonDisabled ? "#B0B0B0" : "#055aed"
                                    }
                                  />
                                  <p
                                    className={`text-[12px] ${
                                      isButtonDisabled
                                        ? "text-gray-500"
                                        : "text-[#055aed]"
                                    }`}
                                  >
                                    {item?.certificate?.key
                                      ? "View Certificate"
                                      : "--"}
                                  </p>
                                </div>

                                <div className="flex flex-col items-start">
                                  <div className="flex items-center gap-1">
                                    {statusIcon()}
                                    {statusText()}
                                  </div>
                                </div>
                              </div>

                              {certificateStatus !== "pending" && (
                                <>
                                  <p className="text-left text-[13px] text-[#758edc] ml-4">
                                    by{" "}
                                    {item?.certificate?.actionBy
                                      ? capitalizeFirstLetter(
                                          item.certificate.actionBy,
                                        )
                                      : "Unknown"}
                                  </p>
                                  {item?.certificate?.reason && (
                                    <p className="text-gray-400 text-[12px] italic ml-4">
                                      {item.certificate.reason}
                                    </p>
                                  )}
                                </>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <p className="text-[14px] mt-2">
                          No certificates available
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* License Info for Nurse */}
                {user?.role === "nurse" &&
                  user?.expirence?.licenseInfo?.status &&
                  user?.expirence?.licenseInfo?.nurse?.councilName &&
                  user?.subRole !== "nursing-assistant" && (
                    <div>
                      <h2 className="text-blue-600 text-[16px] min-w-[80px] mb-2">
                        License :
                      </h2>

                      <p className="text-[#8E8E8E] text-[14px] mb-2">
                        State Of Registration:
                      </p>
                      <p className="text-[14px] mb-4">
                        {user?.expirence?.licenseInfo?.nurse?.councilName ||
                          "N/A"}
                      </p>

                      <p className="text-[#8E8E8E] text-[14px] mb-2">
                        RN/RM/ RANM /RHV/RLHV:
                      </p>
                      <div className="flex flex-row items-center gap-2">
                        <div className="flex flex-row items-center border py-1 px-2 gap-2 w-fit">
                          <p className="text-[14px]">
                            {user?.expirence?.licenseInfo?.nurse
                              ?.licenseNumber || "N/A"}
                          </p>

                          {user?.expirence?.licenseInfo?.nurse
                            ?.licenseNumber && (
                            <div className="flex items-center gap-1">
                              <FiCopy
                                className="cursor-pointer text-[#055AED] hover:text-[#003EB3]"
                                size={16}
                                title="Copy"
                                onClick={handleCopy}
                              />
                              {copied && (
                                <span className="text-blue-600 text-[12px] font-medium">
                                  Copied!
                                </span>
                              )}
                            </div>
                          )}
                        </div>

                        <div className="ml-2">
                          <div className="flex items-center gap-1">
                            {getStatusIcon()}
                            {getStatusText()}
                          </div>
                          {user?.licenseInfo?.actionBy && (
                            <div>
                              <p className="text-left text-[13px] text-[#758edc]">
                                by {user?.licenseInfo?.actionBy}
                              </p>
                              <p className="text-gray-400 text-[12px] italic">
                                {user?.licenseInfo?.reason}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>

                      {user?.licenseInfo?.status === "pending" && (
                        <div className="flex gap-4 mt-4">
                          <button
                            className="bg-white text-[#055AED] border border-[#055AED] hover:bg-[#f0f4ff] px-4 py-1.5 rounded-md text-sm font-medium"
                            onClick={() =>
                              handleLicenseVerification("rejected")
                            }
                          >
                            Decline
                          </button>
                          <button
                            className="bg-[#055AED] text-white hover:bg-[#003EB3] px-4 py-1.5 rounded-md text-sm font-medium"
                            onClick={() =>
                              handleLicenseVerification("accepted")
                            }
                          >
                            Accept
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                {/* License ask to update when not provided */}
                {user?.role !== "patient" &&
                  !user?.expirence?.licenseInfo?.status &&
                  !user?.expirence?.licenseInfo?.actionBy &&
                  user?.address &&
                  Object.keys(user.address).length !== 0 && (
                    <div className="mb-6">
                      <p className="mb-2 text-blue-600 text-[16px]  min-w-[80px]">
                        License:
                      </p>

                      <div className="flex items-center gap-3">
                        <button
                          className={`px-4 py-1.5 rounded-md text-[13px] font-medium border transition duration-200 ${
                            (user?.role === "nurse" &&
                              user?.licenseInfo?.status === "rejected") ||
                            (user?.role === "physiotherapist" &&
                              user?.expirence?.licenseInfo?.status ===
                                "rejected")
                              ? "text-gray-400 border-gray-300 bg-gray-100 cursor-not-allowed"
                              : "text-[#055AED] border-[#055AED] hover:bg-[#f0f4ff]"
                          }`}
                          onClick={() => handleAskVerification("license")}
                          disabled={
                            (user?.role === "nurse" &&
                              user?.licenseInfo?.status === "rejected") ||
                            (user?.role === "physiotherapist" &&
                              user?.expirence?.licenseInfo?.status ===
                                "rejected")
                          }
                        >
                          Ask to Update
                        </button>

                        {user?.role === "nurse" &&
                          user?.licenseInfo?.status === "rejected" && (
                            <p className="text-[13px] text-red-500 font-medium">
                              Request Already Sent
                            </p>
                          )}

                        {user?.expirence?.licenseInfo?.status === "rejected" &&
                          user?.role === "physiotherapist" && (
                            <p className="text-[13px] text-red-500 font-medium">
                              Request Already Sent
                            </p>
                          )}

                        <button
                          className="text-[#fa9450] underline text-[12px] font-medium"
                          onClick={handleAlreadyLicenseVerification}
                        >
                          Already Verified?
                        </button>
                      </div>
                    </div>
                  )}

                {/* License status when only status+actionBy exist but no details */}
                {user?.role !== "patient" &&
                  user?.expirence?.licenseInfo?.status &&
                  user?.expirence?.licenseInfo?.actionBy &&
                  !user?.expirence?.licenseInfo?.nurse?.councilName &&
                  !user?.expirence?.licenseInfo?.physiotherapist
                    ?.IAPCertificate && (
                    <div>
                      <p className="mb-2 text-blue-600 text-[16px] min-w-[80px]">
                        License :
                      </p>
                      <p className="text-[13px] text-green-600 bg-gray-100 rounded-md py-1 px-2 flex items-center">
                        {user?.expirence?.licenseInfo?.status === "accepted" ? (
                          <>
                            <MdVerified
                              color="#00AA44"
                              size={12}
                              style={{ marginRight: 5 }}
                            />
                            Verified
                          </>
                        ) : (
                          "Request already sent"
                        )}
                      </p>
                    </div>
                  )}

                {/* IAP section for Physio */}
                {showIAPSection && (
                  <div>
                    <p className="text-[#8E8E8E] text-[14px] min-w-[80px]">
                      IAP Certificate
                    </p>

                    <div className="mt-2">
                      <div className="flex flex-row items-center gap-4 mb-2">
                        <div
                          className="bg-[#e6f2fa] rounded-[10px] p-2 flex items-center gap-1 mt-1 cursor-pointer"
                          onClick={() =>
                            handleAddClick(
                              "IAP Certificate",
                              iapUrl,
                              "IAP Certificate",
                              status,
                            )
                          }
                        >
                          <IoDocumentOutline color="#055aed" />
                          <p className="text-[12px] text-[#055aed]">
                            View Certificate
                          </p>
                        </div>

                        <div className="flex items-center gap-1">
                          {status === "accepted" && (
                            <>
                              <AiOutlineExclamationCircle
                                color="#00AA44"
                                size={12}
                              />
                              <p className="text-[#00AA44] text-[13px]">
                                Verified
                              </p>
                            </>
                          )}
                          {status === "pending" && (
                            <>
                              <AiOutlineExclamationCircle
                                color="#FFB900"
                                size={12}
                              />
                              <p className="text-[#FFB900] text-[13px]">
                                Pending
                              </p>
                            </>
                          )}

                          {status === "rejected" && (
                            <>
                              <MdCancel color="#FF0000" size={12} />
                              <p className="text-[#FF0000] text-[13px]">
                                Rejected
                              </p>
                            </>
                          )}
                        </div>
                      </div>

                      {status && licenseInfo?.actionBy && (
                        <>
                          <p className="text-[#758edc] text-[13px]">
                            by {licenseInfo?.actionBy || "Unknown"}
                          </p>
                          {licenseInfo?.reason && (
                            <p className="text-gray-400 text-[12px] italic">
                              {licenseInfo.reason}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Availability Info */}
              {user?.role !== "patient" && (
                <>
                  <div className="border-t border-gray-200 mt-[10px]"></div>
                  <div className="flex flex-col p-8 bg-white">
                    <div>
                      <div className="flex items-center mb-4">
                        <img
                          src={CommonImages.exp}
                          className="h-4 w-4 object-contain"
                          alt="Contact Icon"
                        />
                        <p className="text-[#4951EC] ml-3 text-[14px]">
                          Availability Info
                        </p>
                      </div>

                      <div className="flex mt-6">
                        <div className="w-[40%] pr-8">
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Start Date
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Service City
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Service Area's
                          </p>

                          {user?.role === "nurse" && (
                            <>
                              <p className="text-[#8E8E8E] text-[14px] mb-4">
                                Duty Type
                              </p>
                              <p className="text-[#8E8E8E] text-[14px] mb-4">
                                Oncall Duty
                              </p>
                            </>
                          )}

                          {user?.role === "physiotherapist" && (
                            <p className="text-[#8E8E8E] text-[14px] mb-4">
                              Session Info
                            </p>
                          )}

                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Onetime shift Duration
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Regular shift Duration
                          </p>
                          <p className="text-[#8E8E8E] text-[14px] mb-4">
                            Regular shift services
                          </p>
                        </div>

                        <div className="w-[60%]">
                          <p className="text-[14px] font-normal mb-4">
                            {user?.availabilityInfo?.startDate
                              ? moment(
                                  user?.availabilityInfo?.startDate,
                                ).isValid()
                                ? moment(
                                    user?.availabilityInfo?.startDate,
                                  ).format("DD-MM-YYYY")
                                : "N/A"
                              : "N/A"}
                          </p>

                          <p className="text-[14px] font-normal mb-4">
                            {user?.availabilityInfo?.areas?.length
                              ? [
                                  ...new Set(
                                    user?.availabilityInfo?.areas.map(
                                      (a) => a.district,
                                    ),
                                  ),
                                ].join(", ")
                              : "N/A"}
                          </p>

                          <p className="text-[14px] font-normal mb-4">
                            {user?.availabilityInfo?.areas?.length
                              ? user?.availabilityInfo?.areas
                                  .map((a) => a.city)
                                  .join(" , ")
                              : "N/A"}
                          </p>

                          {user?.role === "nurse" &&
                          user?.availabilityInfo?.completed === true ? (
                            <p className="text-[14px] font-normal mb-4">
                              {user?.availabilityInfo?.oneTimeVisits ||
                              user?.availabilityInfo?.regularShifts
                                ? `${
                                    user?.availabilityInfo?.oneTimeVisits
                                      ? "One Time Visit"
                                      : ""
                                  }${
                                    user?.availabilityInfo?.oneTimeVisits &&
                                    user?.availabilityInfo?.regularShifts
                                      ? " , "
                                      : ""
                                  }${
                                    user?.availabilityInfo?.regularShifts
                                      ? "Regular Shift"
                                      : ""
                                  }`
                                : "N/A"}
                            </p>
                          ) : (
                            <p className="text-[14px] font-normal mb-4">N/A</p>
                          )}

                          {user?.role === "nurse" && (
                            <p className="text-[14px] font-normal mb-4">
                              {user?.availabilityInfo?.completed === true
                                ? user?.onCallDuty !== false
                                  ? "ON"
                                  : "OFF"
                                : "N/A"}
                            </p>
                          )}

                          {user?.role === "physiotherapist" && (
                            <p className="text-[14px] font-normal mb-4">
                              {user?.availabilityInfo?.completed === true ? (
                                user?.availabilityInfo?.regularShifts
                                  ?.sessionInfo ? (
                                  <>
                                    <span>
                                      From:{" "}
                                      {moment(
                                        user?.availabilityInfo?.regularShifts
                                          ?.sessionInfo?.fromTime,
                                      ).isValid()
                                        ? moment(
                                            user?.availabilityInfo
                                              ?.regularShifts?.sessionInfo
                                              ?.fromTime,
                                          ).format("MM-DD-YYYY")
                                        : "N/A"}
                                    </span>
                                    <span className="ml-4">
                                      To:{" "}
                                      {moment(
                                        user?.availabilityInfo?.regularShifts
                                          ?.sessionInfo?.toTime,
                                      ).isValid()
                                        ? moment(
                                            user?.availabilityInfo
                                              ?.regularShifts?.sessionInfo
                                              ?.toTime,
                                          ).format("MM-DD-YYYY")
                                        : "N/A"}
                                    </span>
                                    <span className="text-[blue] ml-8">
                                      Fee: ₹{" "}
                                      {user?.availabilityInfo?.regularShifts
                                        ?.sessionInfo?.fees
                                        ? `${user?.availabilityInfo?.regularShifts?.sessionInfo?.fees} -/Per Session`
                                        : "N/A"}
                                    </span>
                                  </>
                                ) : (
                                  "No session info available"
                                )
                              ) : (
                                "N/A"
                              )}
                            </p>
                          )}

                          <p className="text-[14px] font-normal mb-4">
                            {user?.availabilityInfo?.oneTimeVisits
                              ?.shiftDuration?.length > 0
                              ? user?.availabilityInfo?.oneTimeVisits?.shiftDuration.join(
                                  " , ",
                                )
                              : "N/A"}
                          </p>
                          <p className="text-[14px] font-normal mb-4">
                            {user?.availabilityInfo?.regularShifts
                              ?.shiftDuration?.length > 0
                              ? user?.availabilityInfo?.regularShifts?.shiftDuration.join(
                                  " , ",
                                )
                              : "N/A"}
                          </p>
                          <p className="text-[14px] font-normal mb-4">
                            {user?.serviceInfo?.regularServices?.length
                              ? user.serviceInfo.regularServices.join(" , ")
                              : "N/A"}
                          </p>
                        </div>
                      </div>

                      {/* Nurse Regular Shifts Slots */}
                      {user?.role === "nurse" && (
                        <div>
                          {user?.availabilityInfo?.regularShifts?.slots
                            ?.length ? (
                            <div className="overflow-x-auto mt-4">
                              <p className="text-[blue] text-[14px] mb-4">
                                Regular shift slots
                              </p>
                              <table className="min-w-[80%] table-auto border-collapse border border-gray-300">
                                <thead>
                                  <tr className="bg-gray-100 border-b">
                                    <th className="py-2 px-4 text-left text-[blue] text-[13px] font-normal">
                                      Fee
                                    </th>
                                    <th className="py-2 px-4 text-left text-[blue] text-[13px] font-normal">
                                      Shift
                                    </th>
                                    <th className="py-2 px-4 text-left text-[blue] text-[13px] font-normal">
                                      Slot
                                    </th>
                                    <th className="py-2 px-4 text-left text-[blue] text-[13px] font-normal">
                                      Type
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {user?.availabilityInfo?.regularShifts?.slots?.map(
                                    (slot, index) => (
                                      <tr
                                        key={index}
                                        className="border-b hover:bg-gray-50"
                                      >
                                        <td className="py-2 px-4 text-[13px]">
                                          ₹ {slot.fee || "N/A"}
                                        </td>
                                        <td className="py-2 px-4 text-[13px]">
                                          {capitalizeFirstLetter(slot.shift) ||
                                            "N/A"}
                                        </td>
                                        <td className="py-2 px-4 text-[13px]">
                                          {Array.isArray(slot.slots) &&
                                          slot.slots.length > 0
                                            ? slot.slots.join(", ")
                                            : "N/A"}
                                        </td>
                                        <td className="py-2 px-4 text-[13px]">
                                          {slot.type || "N/A"}
                                        </td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </table>
                            </div>
                          ) : null}
                        </div>
                      )}

                      {/* Nurse One-time visit slots */}
                      {user?.role === "nurse" &&
                        user?.serviceInfo?.oneTimeServices?.length > 0 && (
                          <div className="overflow-x-auto mt-4">
                            <p className="text-[blue] text-[14px] mb-4">
                              One time visit slots
                            </p>
                            <table className="min-w-[80%] table-auto border-collapse border border-gray-300 mt-2">
                              <thead>
                                <tr className="bg-gray-100 border-b">
                                  <th className="py-2 px-3 text-left text-[blue] text-[13px] font-normal">
                                    Fee
                                  </th>
                                  <th className="py-2 px-3 text-left text-[blue] text-[13px] font-normal">
                                    Service Type
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {user?.serviceInfo?.oneTimeServices
                                  ?.filter(
                                    (slot) =>
                                      slot.serviceType !== "Personal Care",
                                  )
                                  .map((slot, index) => (
                                    <tr
                                      key={index}
                                      className="border-b hover:bg-gray-50"
                                    >
                                      <td className="py-2 px-4 text-[13px]">
                                        {slot.fee ? `₹ ${slot.fee}` : "N/A"}
                                      </td>
                                      <td className="py-2 px-4 text-[13px]">
                                        {capitalizeFirstLetter(
                                          slot.serviceType,
                                        ) || "N/A"}
                                      </td>
                                    </tr>
                                  ))}

                                {user?.serviceInfo?.oneTimeServices
                                  ?.filter(
                                    (slot) =>
                                      slot.serviceType === "Personal Care",
                                  )
                                  .map((slot, index) => (
                                    <tbody key={index}>
                                      <tr className="border-b hover:bg-gray-50">
                                        <td
                                          colSpan="2"
                                          className="py-2 px-4 text-[13px] font-bold"
                                        >
                                          {capitalizeFirstLetter(
                                            slot.serviceType,
                                          )}
                                        </td>
                                      </tr>
                                      {slot.services?.map(
                                        (service, serviceIndex) => (
                                          <tr
                                            key={serviceIndex}
                                            className="border-b hover:bg-gray-50"
                                          >
                                            <td className="py-2 px-4 text-[13px]">
                                              {`₹ ${service.fee}`}
                                            </td>
                                            <td className="py-2 px-4 text-[13px]">
                                              {service.name || "N/A"}
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                    </div>
                  </div>
                </>
              )}
            </>
          )}

          {/* Modals */}
          <Modal
            show={showModal}
            onClose={handleCloseModal}
            onSave={handleSave}
            aadhar={aadhar}
            nursingCertificate={nursingCertificate}
            iapCertificate={iAPCertificate}
            verificationType={verificationType}
            phone={user.phone}
            statusAadhaar={user?.aadhaar?.verfied}
            statusCeritify={statusCeritify}
            statusIAP={user?.expirence?.licenseInfo?.status}
            course={course}
            role={user?.role}
          />

          <DpModal isOpen={isImgModalOpen} onClose={closeImgModal}>
            <img
              src={user.profilePicture || CommonImages.defaultDp}
              className="max-w-full max-h-screen"
              alt="Full Profile"
            />
          </DpModal>

          {showAcceptModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-10 w-[90%] max-w-md">
                <h3 className="text-lg font-semibold mb-4 text-center">
                  Add Verification Note
                </h3>
                <input
                  className="w-full border border-gray-300 rounded-md p-2 text-sm mb-4"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    className="px-4 py-1.5 text-sm rounded-md border border-gray-300 hover:bg-gray-100"
                    onClick={() => {
                      setShowAcceptModal(false);
                      setAcceptNote("");
                      setName("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-1.5 text-sm rounded-md bg-[#055AED] text-white hover:bg-[#003EB3]"
                    onClick={() =>
                      handleVerificationSubmit("accepted", name, acceptNote)
                    }
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}

          {showDeclineModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
                <h3 className="text-lg font-semibold mb-4 text-center">
                  Reason for Decline
                </h3>
                <input
                  className="w-full border border-gray-300 rounded-md p-2 text-sm mb-4"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <textarea
                  className="w-full border border-gray-300 rounded-md p-2 text-sm mb-4"
                  rows={3}
                  placeholder="Enter reason"
                  value={declineReason}
                  onChange={(e) => setDeclineReason(e.target.value)}
                />
                <div className="flex justify-end gap-3">
                  <button
                    className="px-4 py-1.5 text-sm rounded-md border border-gray-300 hover:bg-gray-100"
                    onClick={() => {
                      setShowDeclineModal(false);
                      setDeclineReason("");
                      setName("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-1.5 text-sm rounded-md bg-[#055AED] text-white hover:bg-[#003EB3]"
                    onClick={() =>
                      handleVerificationSubmit("rejected", name, declineReason)
                    }
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}

          {showAlreadyModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-md">
                <h3 className="text-lg font-semibold mb-4 text-center">
                  Verified Model
                </h3>
                <input
                  className="w-full border border-gray-300 rounded-md p-2 text-sm mb-4"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <div className="flex justify-end gap-3 mt-6">
                  <button
                    className="px-4 py-1.5 text-sm rounded-md border border-gray-300 hover:bg-gray-100"
                    onClick={() => {
                      setAlreadyModel(false);
                      setAcceptNote("");
                      setName("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-1.5 text-sm rounded-md bg-[#055AED] text-white hover:bg-[#003EB3]"
                    onClick={() =>
                      handleVerificationSubmit("accepted", name, acceptNote)
                    }
                  >
                    Verify
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileDetail;
